import { withAuthorization } from "../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../structure/Page/DefaultPage/DefaultPage";

const AddRentalOrderPageContent = lazy(() => import("./AddRentalOrderPageContent"));

function AddRentalOrderPageInternal() {
    return (
        <DefaultPage>
            <AddRentalOrderPageContent />
        </DefaultPage>
    );
}

export const AddRentalOrderPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER))(
    AddRentalOrderPageInternal
);
